import React, { ReactNode } from "react";
import { theme } from "src/config";
import styled from "styled-components";
import { MicrosoftTeams, GoogleMeeting, Skype, TelephoneIcon,Slack, Zoom, MeetingIcon } from "assets/svg";
import { MeetingType } from "src/types";

export interface IMeetingTypeProps {
  type?: MeetingType;
  onClick?:() => void;
}

export const MeetingTypeIcon = (props: IMeetingTypeProps ):JSX.Element => {
  const {type, onClick} = props;
  switch(type) {
      case MeetingType.GoogleMeeting :  return(<GoogleMeeting width={25} height={25} />);
      case MeetingType.MicrosoftTeams : return(<MicrosoftTeams width={25} height={25} />);
      case MeetingType.Skype: return(<Skype width={25} height={25} />);
      case MeetingType.Phone: return(<TelephoneIcon width={25} height={25} />);
      case MeetingType.Other: return(<TelephoneIcon width={25} height={25} />);
      case MeetingType.Slack: return(<Slack width={25} height={25} />);
      case MeetingType.Zoom:  return(<Zoom width={25} height={25} />);
      case MeetingType.None : return(<MeetingIcon width={25} height={25} />);
      default :               return(<MeetingIcon width={25} height={25} />);
  }
}

